<template>
  <section :style="cssVariables" class="steps-component container">
    <prismic-rich-text
      v-if="title"
      class="font-title text-center mb-4"
      :field="title"
    ></prismic-rich-text>

    <SimpleCarousel :jumps-length="itemsWidthEm * 16">
      <div class="steps-content">
        <div class="steps-row">
          <div v-for="(step, index) in steps" :key="index" class="steps-col">
            <b-img
              thumbnail
              fluid
              :src="step.step_image.url"
              :alt="step.step_image.alt"
              width="300"
              height="300"
            ></b-img>
          </div>
        </div>
        <div class="grid align-items-center">
          <hr
            class="span-full"
            :style="`--hr-width:${(100 / steps.length) * (steps.length - 1)}%`"
          />
          <div class="steps-row span-full">
            <div v-for="({ step_id }, index) in steps" :key="index" class="steps-col">
              <div class="ball m-auto">
                <p class="ball-content">{{ step_id || index + 1 }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="steps-row mt-3">
          <div v-for="(step, index) in steps" :key="index" class="steps-col">
            <prismic-rich-text
              v-if="step.step_title"
              class="font-subtitle"
              :field="step.step_title"
            >
            </prismic-rich-text>
            <p>
              {{ step.step_content }}
            </p>
          </div>
        </div>
      </div>
    </SimpleCarousel>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import SimpleCarousel from 'Components/Prismic/Landings/Slices/Steps/SimpleCarousel.vue';

export default {
  components: {
    SimpleCarousel
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: null,
      steps: null,
      itemsWidthEm: 20
    };
  },
  computed: {
    ...mapGetters('config', ['getPageBackgroundColor']),
    cssVariables() {
      const backgroundColor = this.getPageBackgroundColor;
      const resolveBackgroundColor = backgroundColor
        ? `--background-color: ${backgroundColor};`
        : '';
      return `
        --items-width: ${this.itemsWidthEm}em;
        ${resolveBackgroundColor}
      `;
    }
  },
  created() {
    const { primary, items } = this.slice;
    this.title = primary.title1;
    this.steps = items;
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .font-title > * {
    font-size: 33px;
    font-weight: 500;
    margin-bottom: 1rem;
    @include sm {
      font-size: 27px;
    }
  }
  .font-subtitle > * {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 1rem;
  }
}
.vx-custom-background .steps-component {
  --text-color: white;
  --steps-color: var(--text-color);
}
.steps-component {
  --background-color: white;
  --text-color: #212529;
  --steps-color: #e6e6e6;
  --gap: 1em;
  --items-width: 20em;
  color: var(--text-color);
  display: grid;
  gap: var(--gap);
  .steps-content {
    .steps-row {
      display: grid;
      grid-auto-flow: column;
      justify-items: center;
      gap: var(--gap);
    }
    .steps-col {
      width: var(--items-width);
      text-align: center;
    }
    .ball {
      height: 3rem;
      width: 3rem;
      border-radius: 50%;
      display: grid;
      justify-items: center;
      align-items: center;
      background-color: var(--background-color);
      border: 3px solid var(--steps-color);
      text-align: center;

      &-content {
        display: block;
        color: transparent;
        margin: 0;
        max-width: 0.5em;
      }

      &-content::first-letter {
        color: var(--text-color);
      }
    }

    .grid {
      display: grid;
    }

    .span-full {
      grid-column: 1 / -1;
      grid-row: 1/2;
    }

    .img-thumbnail {
      width: 100%;
      border: none;
      background: transparent;
    }

    hr {
      width: var(--hr-width);
      background-color: var(--steps-color);
    }
  }
}
</style>
